"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Toggle = void 0;
const react_1 = require("react");
const Toggle = ({ isToggleOpen = false, children, }) => {
    const [isOpen, setIsOpen] = (0, react_1.useState)(isToggleOpen);
    const toggle = () => {
        setIsOpen(!isOpen);
    };
    return (children &&
        children({
            isOpen,
            toggle,
        }));
};
exports.Toggle = Toggle;
exports.default = exports.Toggle;
//# sourceMappingURL=index.js.map